module.exports = __webpack_public_path__ + "img/bg27.f6a56ac8.jpeg";